import {computed} from "vue";

export function useFormData() {

  const {outputDateFromDb} = useCrudConverters();



  const parseDateFormatTokens = (input, luxon) => {
    if (!input || typeof input !== 'string') return input

    return input.replace(/{{df::(.*?):(.*?)}}/g, (_, format, date) => {
      try {
        const dt = luxon.fromISO(date, { zone: 'utc' }).toLocal()
        return dt.toFormat(format.trim())
      } catch (e) {
        console.warn(`Failed to parse token: {{df::${format}:${date}}}`, e)
        return ''
      }
    })
  }

  const radiusSelect = computed(() => {
    return [
      { label: "5 miles", value: 5 },
      { label: "10 miles", value: 10 },
      { label: "20 miles", value: 20 },
      { label: "35 miles", value: 35 },
      { label: "50 miles", value: 50 },
    ]
  });
  const playersPerTeamSelect = computed(() => {
    return [
      {value: 1, text: '1 - Singles'},
      {value: 2, text: '2 - Doubles'},
      {value: 3, text: '3'},
      {value: 4, text: '4'},
      {value: 5, text: '5'},
      {value: 6, text: '6'},
      {value: 7, text: '7'},
      {value: 8, text: '8'},
      {value: 9, text: '9'},
      {value: 10, text: '10'},
      {value: 11, text: '11'},
      {value: 12, text: '12'},
      {value: 13, text: '13'},
      {value: 14, text: '14'},
      {value: 15, text: '15'},
      {value: 16, text: '16'},
      {value: 17, text: '17'},
      {value: 18, text: '18'},
      {value: 19, text: '19'},
      {value: 20, text: '20'},
    ]
  });

  const timeSelect = computed(() => {
    return [
      '00:00',
      '01:00',
      '02:00',
      '03:00',
      '04:00',
      '05:00',
      '06:00',
      '07:00',
      '08:00',
      '09:00',
      '10:00',
      '11:00',
      '12:00',
      '13:00',
      '14:00',
      '15:00',
      '16:00',
      '17:00',
      '18:00',
      '19:00',
      '20:00',
      '21:00',
      '22:00',
      '23:00',
    ]
  });

  const rolloverOptions = [
    {value: 0, label: 'No promotion/relegation'},
    {value: 1, label: '1 up, 1 down'},
    {value: 2, label: '2 up, 2 down'},
    {value: 3, label: '3 up, 3 down'},
  ];

  const cycleItemTitle = (item) => {
    if (!item || !item.id) return '';
    if(item.startTime && item.endTime) {
      return (
          item.name +
          ' : ' +
          item.startDate +
          ' - ' +
          item.endDate +
          (item.isActive ? ' (active)' : ' (inactive)')
      );
    }
    return (
        item.name +
        ' : ' +
        outputDateFromDb(item.startDate) +
        ' - ' +
        outputDateFromDb(item.endDate) +
        (item.isActive ? ' (active)' : ' (inactive)')
    );
  };

  function transformCycle(cycle) {
    if (!cycle || !cycle.rolloverCycle) return cycle;
    cycle.leagueCycleDivisions.forEach((division, divisionIndex) => {
      division.teams.forEach((team) => {
        const { lastTeam, lastDivisionIndex, lastDivisionName } = findLastTeamInfo(cycle, team);
        team.divisionChange = lastDivisionIndex - divisionIndex;
        team.lastPoints = lastTeam ? lastTeam.totalPoints : 0;
        team.lastPosition = lastTeam ? lastTeam.position : 0;
        team.lastDivision = lastDivisionIndex;
        team.lastDivisionName = lastDivisionName;
      });
      division.teams.sort((a, b) => ((a.lastPosition || 0) + ((a.lastDivision || 0) * 1000)) - ((b.lastPosition || 0) + ((b.lastDivision || 0) * 1000)));
    });
    return cycle;
  }

  function findLastTeamInfo(cycle, team) {
    if (!team.players || team.players.length === 0) {
      return { lastTeam: null, lastDivisionIndex: 0, lastDivisionName: null };
    }

    const currentPlayerIds = team.players.map(p => p.id).sort().join(',');

    for (const division of cycle.rolloverCycle.leagueCycleDivisions) {
      for (const divisionTeam of division.teams) {
        if (!divisionTeam.players || divisionTeam.players.length === 0) continue;

        const divisionPlayerIds = divisionTeam.players.map(p => p.id).sort().join(',');

        if (divisionPlayerIds === currentPlayerIds) {
          return {
            lastTeam: divisionTeam,
            lastDivisionIndex: division.sort,
            lastDivisionName: division.name
          };
        }
      }
    }

    return { lastTeam: null, lastDivisionIndex: 0, lastDivisionName: null };
  }


  return {
    rolloverOptions,
    playersPerTeamSelect,
    timeSelect,
    radiusSelect,
    cycleItemTitle,
    transformCycle,
    findLastTeamInfo,
    parseDateFormatTokens
  };
}

